import { useEffect, useState } from 'react'
import { fetchProviderPing } from '@/api/coaching'

export interface LLMProviderInfo {
  provider: 'anthropic' | 'ollama'
  model: string
  ready: boolean
  /** Whether the default model streams a summarized thinking section first (false for Haiku and Ollama). */
  thinks: boolean
  /** Models a letter can be written with; `model` is the default. Empty on Ollama. */
  models: CoachingModelOption[]
  /** Prepaid Anthropic credit (USD); the app shows roughly what's left. Null when not set. */
  creditUsd: number | null
}

export interface CoachingModelOption {
  id: string
  blurb: string
  thinks: boolean
}

export function useLLMProvider(): LLMProviderInfo | undefined {
  const [info, setInfo] = useState<LLMProviderInfo | undefined>()

  useEffect(() => {
    fetchProviderPing()
      .then((d) => {
        if (d.provider === 'anthropic' || d.provider === 'ollama') {
          setInfo({
            provider: d.provider,
            model: d.model ?? 'unknown',
            ready: d.ready ?? false,
            thinks: d.thinks ?? false,
            models: d.models ?? [],
            creditUsd: d.creditUsd ?? null,
          })
        }
      })
      .catch(() => {})
  }, [])

  return info
}
